<!--  -->
<template>
  <div>

    <div class="choose_account">
      <div class="choose_title">选择的公众号：</div>
      {{ idname }}
      <el-tag style="margin-left:10px" @click="chooseaccount">{{ id ? '选择公众号' :'选择公众号' }}</el-tag>
    </div>
    <div class="choose_account">
      <div class="choose_title">绑定手机编码：</div>
      <el-input v-model="mobilephonecode" style="width:250px" placeholder="手机编码" />
    </div>
    <div class="choose_account">
      <div class="choose_title">个人微信号：</div>
      <el-input v-model="personalwecaht" style="width:250px" placeholder="个人微信号" />
    </div>
    <div>
      <el-button type="primary" style="margin:20px 0px 0px 300px" @click="savew">保存</el-button>
    </div>
    <el-dialog
      title="选择公众号"
      :modal-append-to-body="false"
      :append-to-body="true"
      :visible.sync="dialogVisible"
    >
      <chooseaccount ref="chooseview" @callback="callback" />
    </el-dialog>

  </div>
</template>

<script>
import chooseaccount from '../../bitsetting/components/chooseaccount.vue'
import { creatpeople, editpeople } from '@/api/sourceMaterial.js'
export default {
  components: {
    chooseaccount
  },
  data() {
    return {
      mobilephonecode: '', // 绑定手机编码
      personalwecaht: '', // 个人微信号：
      dialogVisible: false, // 弹窗
      id: '', // 选择的公众号id
      idname: '', // 选择的公众号名称

      addtype: null,

      ids: null
    }
  },
  created() {

  },
  mounted() {

  },
  methods: {
    chooseaccount() {
      this.dialogVisible = true
      this.$nextTick(() => {
        this.$refs.chooseview.send(this.id)
      })
    },
    callback(val) {
      console.log('val', val)
      this.id = val.authorizer_appid
      this.idname = val.account_name
      this.dialogVisible = false
    },
    send(val, item) {
      if (val === 1) {
        this.addtype = val
        console.log('新增')
      } else {
        this.addtype = val
        console.log('编辑', item)
        this.id = item.app_id
        this.idname = item.account_name
        this.ids = item.id
        this.mobilephonecode = item.phone_name
        this.personalwecaht = item.phone_vx_account
      }
      console.log('val', val)
    },
    async savew() {
      if (this.id === '') {
        this.$message.error('请选择的公众号')
        return
      }
      if (this.mobilephonecode === '') {
        this.$message.error('请输入手机编码')
        return
      }
      if (this.personalwecaht === '') {
        this.$message.error('请输入个人微信号')
        return
      }
      if (this.addtype === 1) {
        const data = await creatpeople({
          appId: this.id,
          phoneVxAccount: this.personalwecaht,
          phoneName: this.mobilephonecode
        })
        this.$message({
          message: '添加成功',
          type: 'success'
        })
        this.$emit('updatawe')
        console.log('data', data)
      } else {
        console.log('this.id', this.id)
        const data = await editpeople({
          id: this.ids,
          appId: this.id,
          phoneVxAccount: this.personalwecaht,
          phoneName: this.mobilephonecode
        })
        this.$message({
          message: '修改成功',
          type: 'success'
        })
        this.$emit('updatawe')
        console.log('data', data)
      }
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.choose_account{
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}
.choose_title{
  width: 100px;
  text-align: right;
}
</style>
